import { GdprStorage } from "shared/src/uidispatcherapi/GdprStorage";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import SearchResultStore from "../../../stores/SearchResultStore";

import { RecentSearchesSuggestion, RecentSearchesData } from "../../../datatypes/ArticleSuggestions";

export function saveRecentSearches() {
    const searchedTerm = GdprStorage.localStorage.get("previouslySearchedTerm").actualResult;
    const previouslySearchedTerm: RecentSearchesData[] = searchedTerm ? JSON.parse(searchedTerm) : [];
    const searchResult = SearchResultStore.getState();
    const query = searchResult?.q?.toLowerCase().trim() ?? "";
    const userId = SessionStore.getEmployeeId() || SessionStore.getCustomerId();
    const newSearchedTerm = {
        query: query,
        count: 1,
        userId: userId
    };
    let newSearchedTermExisting = false;
    for (let i = 0; i < previouslySearchedTerm.length; i++) {
        if (
            newSearchedTerm.query === previouslySearchedTerm[i].query &&
            newSearchedTerm.userId === previouslySearchedTerm[i].userId
        ) {
            previouslySearchedTerm[i].count++;
            newSearchedTermExisting = true;
        }
    }
    if (!newSearchedTermExisting) {
        previouslySearchedTerm.push(newSearchedTerm);
    }
    const mostRecentSearches = previouslySearchedTerm.sort((a, b) => b.count - a.count).slice(0, 100);
    GdprStorage.localStorage.put("previouslySearchedTerm", JSON.stringify(mostRecentSearches), GdprStorage.FUNCTIONAL);
}

export function loadRecentSearches(): Array<RecentSearchesSuggestion> {
    const searches = GdprStorage.localStorage.get("previouslySearchedTerm").actualResult;
    const recentSearches: RecentSearchesData[] = searches ? JSON.parse(searches) : [];
    const recentSearchesDeduplicated: RecentSearchesData[] = [];
    // Remove duplicates since the same queries might be stored locally for different users
    recentSearches.forEach((item) => {
        const duplicateItem: RecentSearchesData | undefined = recentSearchesDeduplicated.find(
            (deduplicatedItem) => deduplicatedItem.query === item.query
        );
        if (!duplicateItem) {
            recentSearchesDeduplicated.push(item);
        }
    });
    const recentSearchesResult = recentSearchesDeduplicated
        .filter((item) => item && item.query)
        .map((item) => {
            return {
                type: "RECENT_SEARCH" as const,
                icon: {
                    className: "icon-small-magnify",
                    position: "front" as const
                },
                recentSearches: item
            };
        });
    return recentSearchesResult;
}
